/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { TelemetryActivityWindowParam } from '@/client';
import { ACTIVITY_WINDOWS } from '@/hooks/query/useTenantActivityInfiniteQuery';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Select } from '@/primitives/Select';

type ActivityWindowSelectProps = {
  value: TelemetryActivityWindowParam;
  onChange: (value: TelemetryActivityWindowParam) => void;
};

export function ActivityWindowSelect({ value, onChange }: ActivityWindowSelectProps) {
  const { t } = useMimicTranslation('activity');

  const options = ACTIVITY_WINDOWS.map((w) => ({
    label: t(`window.${w}` as 'window.1h'),
    value: w,
  }));

  return (
    <Select
      value={value}
      onChange={(v) => onChange(v as TelemetryActivityWindowParam)}
      options={options}
      style={{ minWidth: 160 }}
      data-testid="activity-window-button"
    />
  );
}
